import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useI18n } from 'builder/hooks/useI18n'
import { FileInput } from 'builder/components/PhotoUploadField/styles'
import { ALLOWED_FILES } from 'builder/components/FillResumeModal/constants'
import { actions as panelActions } from 'builder/modules/panel'
import { DocumentTypes } from 'builder/modules/constants'
import { ResumeDistributionLayout } from '../ResumeDistributionLayout/ResumeDistributionLayout'
import { AvailableCountriesBanner } from '../AvailableCountriesBanner/AvailableCountriesBanner'
import { LOCALIZATION_KEY } from '../../constants'
import {
  Container,
  TitleContainer,
  Title,
  SubTitle,
  OptionsContainer,
  CardContainer,
  IconWrapper,
  IconUpload,
  CardContentWrapper,
  CardTitle,
  CardSubTitle,
  DividerContainer,
  DividerText,
  IconCreate,
} from './styles'

type Props = {
  handleUploadClick: (event: React.MouseEvent<HTMLInputElement>) => void
  handleFileInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const WithoutResumeScreen = (props: Props) => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const { handleUploadClick, handleFileInputChange } = props

  const handleCreateResume = useCallback(() => {
    dispatch(
      panelActions.createDocument({
        type: DocumentTypes.resume,
        isResumeDistributionCreateAction: true,
      }),
    )
  }, [dispatch])

  return (
    <ResumeDistributionLayout>
      <Container>
        <TitleContainer>
          <Title>{i18n.t(`${LOCALIZATION_KEY}.welcome_screen.title`)}</Title>
          <SubTitle>{i18n.t(`${LOCALIZATION_KEY}.welcome_screen.subtitle`)}</SubTitle>
        </TitleContainer>
        <AvailableCountriesBanner />
        <OptionsContainer>
          <CardContainer htmlFor="file-resume-upload">
            <IconWrapper>
              <IconUpload />
            </IconWrapper>
            <CardContentWrapper>
              <CardTitle>{i18n.t(`${LOCALIZATION_KEY}.options.upload_resume.title`)}</CardTitle>
              <CardSubTitle>
                {i18n.t(`${LOCALIZATION_KEY}.options.upload_resume.subtitle`)}
              </CardSubTitle>
            </CardContentWrapper>
            <FileInput
              type="file"
              onClick={handleUploadClick}
              onChange={handleFileInputChange}
              accept={ALLOWED_FILES}
              id="file-resume-upload"
            />
          </CardContainer>
          <DividerContainer>
            <DividerText>{i18n.t(`${LOCALIZATION_KEY}.options.divider_text`)}</DividerText>
          </DividerContainer>
          <CardContainer onClick={handleCreateResume}>
            <IconWrapper>
              <IconCreate />
            </IconWrapper>
            <CardContentWrapper>
              <CardTitle>{i18n.t(`${LOCALIZATION_KEY}.options.create_resume.title`)}</CardTitle>
              <CardSubTitle>
                {i18n.t(`${LOCALIZATION_KEY}.options.create_resume.subtitle`)}
              </CardSubTitle>
            </CardContentWrapper>
          </CardContainer>
        </OptionsContainer>
      </Container>
    </ResumeDistributionLayout>
  )
}
